import { oz } from '@weft/utils';
import { DynamicInvoiceMeterUsageSchema } from './dynamic-invoice-meter-usage-schema';

export const DynamicInvoiceMeasurementChartMeterUsageSchema = oz.record(oz.string(), DynamicInvoiceMeterUsageSchema);

export type DynamicInvoiceMeasurementChartMeterUsage = oz.infer<typeof DynamicInvoiceMeasurementChartMeterUsageSchema>;